import { __rest } from "tslib";
import React from 'react';
import { default as isTouchDevice } from "@pb/utils/isTouchDevice";
import cn from 'classnames';
import ProductLink from "../../../ProductLink";
import { ProductTileProps } from "../../types";
import ProductVideo from "../../../../micro-apps/ProductVideo";
import styles from './MovingMedia.module.scss';
const MovingMedia = (_a) => {
    var { videoFallbackImage, articleCode, title, videoId, isPlpVideo } = _a, props = __rest(_a, ["videoFallbackImage", "articleCode", "title", "videoId", "isPlpVideo"]);
    return (React.createElement(ProductLink, Object.assign({ useSimpleLink: true, className: cn(isTouchDevice() && styles.touchAdjustments) }, props),
        React.createElement(ProductVideo, { posterImage: {
                url: (videoFallbackImage === null || videoFallbackImage === void 0 ? void 0 : videoFallbackImage.url) || '',
                altText: (videoFallbackImage === null || videoFallbackImage === void 0 ? void 0 : videoFallbackImage.altText) || '',
            }, articleCode: `${articleCode}`, name: title, videoId: `ref:${videoId}`, description: title, key: `video-${articleCode}`, isPlpVideo: isPlpVideo })));
};
export default MovingMedia;
//# sourceMappingURL=MovingMedia.js.map